(function () {


	angular.module('app.widgets')
	.directive('plaTopBar', plaTopBar);

	plaTopBar.$inject = ['UserInfoService'];

	function plaTopBar(UserInfoService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/widgets/topBar.html',
            link: function(scope, element, attrs) {
                userInfoChanged(scope, UserInfoService);
              }
        }
    }

    /** 01. Top Nav
 **************************************************************** **/


function userInfoChanged(scope, UserInfoService){
	scope.$watch(function(){
		return UserInfoService.userInfo.isAuthenticated;
	}, function(newValue){
        scope.isUserAuthenticated = newValue;
    });
    
  scope.$watch(function(){
		return UserInfoService.userInfo.userDisplayName;
	}, function(newValue){
        scope.userDisplayName = newValue;
  });
  
  scope.$watch(function(){
		return UserInfoService.userInfo.companiaNombre;
	}, function(newValue){
        scope.companiaNombre = newValue;
        });
        
   scope.$watch(function(){
   	return UserInfoService.userInfo.companiaId;
   }, function(newValue){
   scope.companiaId = newValue;
   });
};

})();